export const downloadAppLinks = {
    ios: {
        label: "Скачать приложение LIKVI на iOS в App Store",
        href: "https://apps.apple.com/tr/app/likvi/id6498891460"
    },
    appGallery: {
        label: "Скачать приложение LIKVI в App Gallery",
        href: "https://appgallery.huawei.com/app/C113420469"
    },
    apk: {
        label: "Скачать приложение LIKVI на Android",
        href: "https://appgallery.huawei.com/app/C113420469"
    }
};